import { useTranslation } from 'react-i18next';
import { AppSettingsTemplate } from '@ideoz/ui';
import { useMyProfile } from '../modules/profile/useMyProfile';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

/**
 * App Settings page (`/app-settings`): account-level Appearance + Language.
 * Reuses `useMyProfile` purely for the shared shell (startup sidebar, header,
 * user menu) and injects the web `LanguageSwitcher`.
 */
export default function AppSettings(): JSX.Element {
  const { t } = useTranslation();
  const { user, facade } = useMyProfile();

  if (!user) {
    return <div>{t('common.loading')}</div>;
  }

  return <AppSettingsTemplate facade={facade} isWeb languageSwitcher={<LanguageSwitcher />} />;
}
